/**
 * @generated SignedSource<<3b5741fc22d6445a3de0a20fda31670c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignTiles_designPageInfo$data = {
  readonly creatorDesigns: ReadonlyArray<{
    readonly browsePageLinkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly displayName: string | null;
    readonly imageUrl: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbRespDesignTiles_designPageInfo";
};
export type SbRespDesignTiles_designPageInfo$key = {
  readonly " $data"?: SbRespDesignTiles_designPageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignTiles_designPageInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespDesignTiles_designPageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorDesigns",
      "kind": "LinkedField",
      "name": "creatorDesigns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "browsePageLinkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DesignPageInfo",
  "abstractKey": null
};

(node as any).hash = "fc7151d626f2a4d6dc6a2670e77cb374";

export default node;
